import Vue from 'vue'
import App from './App'
import store from "@/store"
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullpage from 'vue-fullpage.js'

import './permission'
import '@/styles/index.scss'
import 'normalize.css/normalize.css'
import VueDND from 'awe-dnd'
import 'animate.css'
import scroll from 'vue-seamless-scroll'
import VueCropper from 'vue-cropper'

Vue.use(VueDND)
Vue.use(ElementUI)
Vue.use(VueFullpage)
Vue.use(scroll)
Vue.use(VueCropper)

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
